<div *ngIf="spinner==true">
    <ngx-spinner size="medium" type="timer">
        <p style="font-size: 20px; color: white;padding-left:7%;">Loading...</p>
    </ngx-spinner>
</div>
<div class="container-fluid">
    <div class="card">
        <!-- <div class="card-header1">
            <div class="d-flex justify-content-between">
                <h4 class="font-weight-bold text-dark py">COURSE ASSIGNED</h4>
          
            </div>
        </div> -->

      <!-- Upcoming Courses Section -->
<div class="card-header" style="background-color: white !important; text-align: center;">
    <div class="d-flex justify-content-between">
        <h4 class="font-weight-bold text-dark py">UPCOMING COURSES</h4>
    </div>
</div>

<div class="container-fluid py-4">
    <div class="row" *ngIf="upcoming_course.length > 0">
        <div class="col-md-12">
            <div class="row">
                <div class="col-sm-6 col-md-4 col-lg-3 mb-4" *ngFor="let item of upcoming_course">
                    <div class="card h-100 shadow-lg" style="border-radius: 12px; border: none; overflow: hidden;">
                        <img class="card-img-top" style="height: 150px; border-radius: 12px 12px 0 0;"
                        src="https://myroots.redmindtechnologies.com/api/{{item.images}}" alt="Card image">
                        <div class="card-body d-flex flex-column">
                            <h5 class="card-title" style="font-weight: bold; font-size: 18px; color: #333;">{{item.course_name}}</h5>
                            <p class="card-text" style="font-size: 14px; color: #555;">{{item.course_des}}</p>
                            <p class="card-text" style="font-size: 14px; color: #777;">Start Date: {{item.course_date | date:'d-M-Y'}}</p>
                            <p class="card-text" style="font-size: 14px; color: #777;">Type: {{item.typeofcourse}}</p>
                            <a href="#" class="btn btn-primary mt-auto" data-toggle="modal" data-target="#showCM"
                                (click)="buttonviewmeeting(item, 'show')">Show</a>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="text-center" *ngIf="upcoming_course.length === 0">
        <p style="margin-top: 150px; font-size: 18px; color: #888;">No Upcoming Courses Available.</p>
    </div>
</div>

<!-- Completed Courses Section -->
<div class="card-header" style="background-color: white !important; text-align: center;">
    <div class="d-flex justify-content-between">
        <h4 class="font-weight-bold text-dark py">COMPLETED COURSES <a routerLink="/mentors/mentorcourselist" routerLinkActive="active" style="font-size: 0.6em;">(Show All)</a>
        </h4>
    </div>
</div>

<div class="container-fluid py-4">
    <div class="row" *ngIf="completed_course.length > 0">
        <div class="col-md-12">
            <div class="row">
                <div class="col-sm-6 col-md-4 col-lg-3 mb-4" *ngFor="let item of completed_course">
                    <div class="card h-100 shadow-sm" style="border-radius: 10px; overflow: hidden; border: 1px solid #ddd;">
                        <img class="card-img-top" style="height: 150px; object-fit: cover;"
                        src="https://myroots.redmindtechnologies.com/api/{{item.images}}" alt="Card image">
                        <div class="card-body d-flex flex-column">
                            <h5 class="card-title" style="font-weight: bold; font-size: 18px;">{{item.course_name}}</h5>
                            <p class="card-text" style="font-size: 14px; flex-grow: 1;">{{item.course_des}}</p>
                            <p class="card-text mb-1" style="font-size: 14px;">Start Date: {{item.course_date | date:'d-M-Y'}}</p>
                            <p class="card-text mb-2" style="font-size: 14px;">Type: {{item.typeofcourse}}</p>
                            <a href="#" class="btn btn-primary mt-auto" data-toggle="modal" data-target="#showCM"
                                (click)="buttonviewmeeting(item, 'show')">Show</a>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="text-center" *ngIf="completed_course.length === 0">
        <p style="margin-top: 150px; font-size: 18px; color: #888;">No Completed Courses Available.</p>
    </div>
</div>

        <!-- <div class="container-fluid py-4">
            <div class="row" *ngIf="mentor_data.length > 0">
              <div class="col-md-12">
                <div class="row">
                  <div class="col-sm-6 col-md-4 col-lg-3 mb-4" *ngFor="let item of mentor_data">
                    <div class="card h-100 shadow-lg" style="border-radius: 12px; border: none; overflow: hidden;">
                      <img class="card-img-top" style="height: 150px; object-fit: cover; border-radius: 12px 12px 0 0;"
                        src="https://myroots.redmindtechnologies.com/api/{{item.image}}" alt="Card image">
                      <div class="card-body d-flex flex-column">
                        <h5 class="card-title" style="font-weight: bold; font-size: 18px; color: #333;">{{item.course_name}}</h5>
                        <p class="card-text" style="font-size: 14px; color: #555;">{{item.course_description}}</p>
                        <p class="card-text" style="font-size: 14px; color: #777;">Start Date: {{item.start_date | date:'d-M-Y'}}</p>
                        <p class="card-text" style="font-size: 14px; color: #777;">Duration: {{item.hours}} Hours</p>
                        <a href="#" class="btn btn-primary mt-auto" data-toggle="modal" data-target="#showCM"
                          (click)="buttonviewmeeting(item, 'show')">Show</a>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="text-center" *ngIf="mentor_data.length === 0">
              <p style="margin-top: 150px; font-size: 18px; color: #888;">No Course Assigned to you. Please contact District Admin</p>
            </div>
          </div> -->
             <!-- <div class="container-fluid card-body ">
            <div class="row" *ngIf="mentor_data.length > 0">
                <div class="col-md-12">
       
        
                    <div class="row">
                        <div class="col-md-2" *ngFor="let item of mentor_data">
                            <div class="card" style="height:200px;width:180px;">
                                <img class="card-img-top" style="height: 100px;"
                                src="https://myroots.redmindtechnologies.com/api/{{item.image}}" alt="Card image">
                                <div class="card-body">
                                    <h4 class="card-title" style="font-weight:bold;font-size:16px;">{{item.course_name}}</h4>
                                    <div class="card-text" style="float:left;font-size: 14px;">{{item.course_description}}</div>
                                    <div class="card-text" style="float:left;font-size: 14px;">Start Date:
                                        {{item.start_date | date:'d-M-Y'}}</div>
                                    <div class="card-text" style="float:left;font-size: 14px;">Duration: {{item.hours}} Hours</div>
                                    <a href="#"  style="float: right; margin-right: 20px;" data-toggle="modal" data-target="#showCM" (click)="buttonviewmeeting(item, 'show')">Show</a>

                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="center-message card-body "  *ngIf="mentor_data.length===0">
                <p style="margin-top: 150%;"> No Course Assigned to you. Please contact District Admin</p>
              </div>
        </div> -->
      

        <div class="modal fade" id="showCM">
            <div class="modal-dialog modal-xl modal-dialog-centered">
                <div class="modal-content">
                    <div class="card ">
                        <div class="card-header  show-header">
                            <h3 class="card-title" style="color:#ddd">COURSES ASSIGNED </h3>
                            <button type="button" class="close" data-dismiss="modal"  style="color:#ddd">&times;</button>
                        </div>
                        <div class="card-body">
                            <form class="register-form" [formGroup]='editmeetingform'
                                (ngSubmit)="updatedata(editmeetingform,CM_id)" autocomplete="off">
                                <div class="form-group row" *ngIf="!editfield && editTopic">
                                    <div class="form-group col-sm-6 ">
                                        <label>Course Name </label><span class="required "> *</span>
                                        <input pInputText type="text" class="form-control"
                                            placeholder="Enter Course Name " [value]="CM_course_name"
                                            readonly="readonly">
                                    </div>
                                    <div class="col-sm-6 mb-3 mb-sm-0">
                                        <label>Subject</label><span class="required "> *</span>
                                        <input pInputText type="text" class="form-control" placeholder="Enter District "
                                            [value]="Topic" readonly="readonly">    
                                    </div>

                                </div>
                                <div class="form-group row" *ngIf="!editfield && !editTopic">

                                <div class="col-sm-12 mb-3 mb-sm-0">
                                    <label>Topic</label><span class="required "> *</span>
                                    <input pInputText type="text" class="form-control" placeholder="Enter District "
                                        [value]="CM_course_name" readonly="readonly">    
                                </div>
</div>
                                <div class="form-group row" *ngIf="!editfield">
                                    <div class="col-sm-6 mb-3 mb-sm-0">
                                        <label>Description</label><span class="required "> *</span>
                                        <input pInputText type="text" class="form-control" placeholder="Enter Constituency"
                                            [value]="CM_Description" readonly="readonly">
                                    </div>
                                    <div class="col-sm-6 mb-3 mb-sm-0">
                                        <label class="form-label">Course Link</label><span class="required">*</span>
                                        <input pInputText type="text" class="form-control"
                                            placeholder="Enter Status" [value]="CM_session_link"
                                            readonly="readonly">
                                
                                    </div>
                                </div>
                                <div class="form-group row" *ngIf="!editfield">
                                    <div class="col-sm-6 mb-3 mb-sm-0">
                                        <label class="form-label">Course Date</label><span class="required">*</span>
                                        <input pInputText type="text" class="form-control" placeholder="Enter Course Start Date"
                                            [value]="CM_startDate" readonly="readonly">
                                
                                    </div>
                                    <div class="col-sm-6 mb-3 mb-sm-0">
                                        <label class="form-label">Course Time</label><span class="required">*</span>
                                        <input pInputText type="text" class="form-control" placeholder="Enter Course Start Time"
                                            [value]="CM_startTime" readonly="readonly">
                                    </div>
                                </div>
                                <div class="form-group row" *ngIf="!editfield">
                                    
                                    <div class="col-sm-6 mb-3 mb-sm-0">
                                        <label class="form-label">Type</label><span class="required">*</span>
                                        <input pInputText type="text" class="form-control" placeholder="Enter Course End Time"
                                            [value]="CM_type" readonly="readonly">
                                
                                    </div>
                                </div>
                                <div class="form-group row" *ngIf="!editfield">
                                    <div class="col-md-12">
                                    <label>Comments</label>
                                    <textarea class="form-control" formControlName="comments" readonly [value]="CM_comments"></textarea>
                                    </div>
                                </div> 

                                <div class="form-group row" *ngIf="editfield">
                                    <div class="col-sm-6 mb-3 mb-sm-0">
                                        <label>Course Name </label><span class="required "> *</span>
                                        <select name="course_name" class="form-control" formControlName="course_name" [(ngModel)]="CM_course_name">
                                            <option value="">Select Course Name</option>
                                            <option *ngFor="let option of courses" [value]="option.id">
                                                {{option['course_name']}}</option>
                                        
                                        </select>
                                
                                    </div>
                                    <div class="col-sm-6 mb-3 mb-sm-0">
                                        <label>District</label><span class="required "> *</span>
                                        <input pInputText type="text" class="form-control" placeholder="Enter District / மாவட்டம்" [value]="CM_district"
                                            readonly="readonly">
                                
                                    </div>
                                
                                </div>
                                <div class="form-group row" *ngIf="editfield">
                                    <div class="col-sm-6 mb-3 mb-sm-0">
                                        <label>Constituency</label><span class="required "> *</span>
                                        <input pInputText type="text" class="form-control" placeholder="Enter Constituency/ வாக்காளர் தொகுதி"
                                            [value]="CM_constituency" readonly="readonly">
                                
                                    </div>
                                    <div class="col-sm-6 mb-3 mb-sm-0">
                                        <label>Organizer</label><span class="required "> *</span>
                                    <select name="organizer" class="form-control" formControlName="organizer"  [(ngModel)]="CM_organizer">
                                        <option value="">Select Organizer</option>
                                        <option value="class">Class</option>
                                        <option *ngFor="let option of ob_data" (value)="option['firstname']">
                                            {{option['firstname']}}</option>

                                    </select>
                                
                                    </div>
                                </div>
                                <div class="form-group row" *ngIf="editfield">
                                    <div class="col-sm-6 mb-3 mb-sm-0">
                                        <label class="form-label">Course Start Date</label><span class="required">*</span>
                                        <input pInputText type="date" class="form-control" placeholder="Enter Course Start Date"
                                            [value]="CM_startDate" >
                                
                                    </div>
                                    <div class="col-sm-6 mb-3 mb-sm-0">
                                        <label class="form-label">Course End Date</label><span class="required">*</span>
                                        <input pInputText type="date" class="form-control" placeholder="Enter Course End Date"
                                            [value]="CM_endDate" >
                                
                                    </div>
                                </div>
                                <div class="form-group row" *ngIf="editfield">
                                    <div class="col-sm-6 mb-3 mb-sm-0">
                                        <label class="form-label">Course Start Time</label><span class="required">*</span>
                                        <input pInputText type="time" class="form-control" placeholder="Enter Course Start Time"
                                            [value]="CM_startTime" >
                                
                                    </div>
                                    <div class="col-sm-6 mb-3 mb-sm-0">
                                        <label class="form-label">Course End Time</label><span class="required">*</span>
                                        <input pInputText type="time" class="form-control" placeholder="Enter Course End Time"
                                            [value]="CM_endTime" >
                                
                                    </div>
                                </div>
                                <div class="form-group row" *ngIf="editfield">
                                    <div class="col-sm-6 mb-3 mb-sm-0">
                                        <label class="form-label">Primary Volunteer</label><span class="required">*</span>
                                        <input pInputText type="text" class="form-control" placeholder="Enter Primary Volunteer"
                                            [value]="CM_volunteer1" >
                                
                                    </div>
                                    <div class="col-sm-6 mb-3 mb-sm-0">
                                        <label class="form-label">Secondary Volunteer</label><span class="required">*</span>
                                        <input pInputText type="text" class="form-control"
                                            placeholder="Enter Secondary Volunteer" [value]="CM_volunteer2"
                                            >
                                
                                    </div>
                                </div>
                                <div class="form-group row" *ngIf="editfield">
                                    <div class="col-sm-6 mb-3 mb-sm-0">
                                        <label class="form-label">Course Location</label><span class="required">*</span>
                                        <input pInputText type="text" class="form-control" placeholder="Enter Course Location"
                                            [value]="CM_location" >
                                
                                    </div>
                                    <div class="col-sm-6 mb-3 mb-sm-0">
                                        <label class="form-label">Status</label><span class="required">*</span>
                                        <select name="status" class="form-control" formControlName="status" [(ngModel)]="CM_status">
                                            <option value="">Select any status </option>
                                            <option>Open</option>
                                            <option>Session Start</option>
                                            <option>Session End</option>
                                            <option>Inprogress</option>
                                            <option>Cancelled</option>
                                            <option>Postponed</option>
                                        </select>
                                
                                    </div>
                                </div>
                                <div class="form-group row" *ngIf="editfield">
                                    <div class="col-md-12">
                                        <label>Comments</label>
                                        <textarea class="form-control" formControlName="comments"  [value]="CM_comments"></textarea>
                                    </div>
                                </div>

                                <div *ngIf="editfield" class="d-flex justify-content-center">
                                    <div style="width:200px">
                                        <button class="btn btn-success btn btn-block">Update District Occurance</button>
                                    </div>
                                </div>

                            </form>

                        </div>
                    </div>
                </div>
            </div>
        </div>

      